// SignupPage.jsx
import React from "react";
import "../Styles/Login.css"; // reuse login styles for signup
import logo from "../Assest/newcluster.png";
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useSearchParams } from "react-router-dom";

const api = process.env.REACT_APP_API_URL;

export default function SignupPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();

const buyerEmail = searchParams.get("email");
const buyerWristbandId = searchParams.get("wristbandId");

const [email, setEmail] = useState(buyerEmail || "");
const [wristbandId, setWristbandId] = useState(buyerWristbandId || "");

// If wristband came from the success page, start on Step 2.
const [step, setStep] = useState(buyerWristbandId ? 2 : 1);

  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };

  const handleCheckWristband = async (e) => {
    e.preventDefault();

    if (!wristbandId.trim()) {
      toast.error("Please enter your wristband ID.");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const { data } = await axios.post(`${api}/check-wristband`, {
        wristbandId: wristbandId.trim(),
      });

  
      if (data.success) {
        // Backend has confirmed this wristband
        setEmail(data.email);
        localStorage.setItem("email", wristbandId.trim());

        setWristbandId(data.wristbandId); // Ensure the wristband ID is set from the backend response
        localStorage.setItem("wristbandId", data.wristbandId);
        // Move to account creation
        setStep(2);

        toast.success("Wristband verified!");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message ||
          "Unable to verify wristband. Please try again.",
      );

      setMessage(err.response?.data?.message || "Unable to verify wristband.");
    } finally {
      setLoading(false);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const { data } = await axios.post(`${api}/signup`, {
        email,
        password,
        wristbandId,
      });

      // store email for later use in verification

      // Optional: store token if backend sends it
      if (data.success) {
        toast.success(
          data.message ||
            "Signup successful! check your email for verification.",
        );
      }

      // Optional redirect
      window.location.href = "/verify-email-info";
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Signup failed. Please try again.",
      );
      setMessage(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card fade-in">
        <div className="logo-container">
          <a href="/">
            <img src={logo} alt="ClusterClear" className="logo" />
          </a>
        </div>

        {step === 1 ? (
          <>
            <h2 className="auth-title">Set Up Your Wristband</h2>

            <p className="auth-subtitle">
              Enter the wristband ID that came with your ClusterClear wristband.
            </p>

            <form className="auth-form" onSubmit={handleCheckWristband}>
              <label>Wristband ID</label>

              <input
                type="text"
                placeholder="CC-XXXXXXXX"
                required
                value={wristbandId}
                onChange={(e) => setWristbandId(e.target.value.toUpperCase())}
              />

              <p
                style={{
                  fontSize: "0.8rem",
                  color: "#777",
                  marginTop: "10px",
                  marginBottom: "18px",
                  lineHeight: "1.5",
                  height: "20px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                You can find your wristband ID on your ClusterClear order
                confirmation.
              </p>

              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? "Verifying..." : "Continue"}
              </button>
            </form>

            <p className="switch-auth">
              Don't have a ClusterClear wristband? <a href="/product">Get yours</a>
            </p>
          </>
        ) : (
          <>
            <h2 className="auth-title">Create Your Account</h2>

            <p className="auth-subtitle">
              Your wristband is ready. Let's get your account set up.
            </p>

            {/* Wristband ID */}
            <div
              style={{
                marginBottom: "18px",
                padding: "12px 14px",
                borderRadius: "8px",
                background: "#f7f7f7",
                fontSize: "0.85rem",
                color: "#555",
              }}
            >
              <strong>Wristband ID:</strong> {wristbandId}
            </div>

            <form className="auth-form" onSubmit={handleSignup}>
              <label>Email</label>

              <input
                type="email"
                placeholder="you@example.com"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <label>Password</label>

              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="********"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    width: "100%",
                    paddingRight: "40px",
                  }}
                />

                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "0.7rem",
                    color: "#555",
                    zIndex: 100,
                  }}
                >
                  {showPassword ? "Hide Password" : "Show password"}
                </span>

                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "0.8rem",
                  }}
                >
                  <p
                    style={{
                      color: checks.length ? "green" : "#999",
                    }}
                  >
                    {checks.length ? "✔" : "•"} At least 8 characters
                  </p>

                  <p
                    style={{
                      color: checks.uppercase ? "green" : "#999",
                    }}
                  >
                    {checks.uppercase ? "✔" : "•"} One uppercase letter
                  </p>

                  <p
                    style={{
                      color: checks.number ? "green" : "#999",
                    }}
                  >
                    {checks.number ? "✔" : "•"} One number
                  </p>

                  <p
                    style={{
                      color: checks.special ? "green" : "#999",
                    }}
                  >
                    {checks.special ? "✔" : "•"} One special character
                  </p>
                </div>
              </div>

              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? "Creating account..." : "Create My Account"}
              </button>
            </form>

            {message && (
              <p
                style={{
                  marginTop: "10px",
                  color: "#555",
                }}
              >
                {message}
              </p>
            )}

            <p className="switch-auth">
              <span
                onClick={() => setStep(1)}
                style={{
                  cursor: "pointer",
                  color: "#555",
                }}
              >
                ← Back
              </span>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
